import Scrollbar from 'smooth-scrollbar';

export const scrollToTop = () => {
  const scrollBar = Scrollbar.init(document.body);
  scrollBar.scrollTo(0, 0, 600);
};
